import thumbnail from '../../../../images/report_thumbnail_tooling.png';
import { ReportV2Dto } from '../../../api';
import { DatasetSlugs } from '../../dataset';

const dimensionsWithDescriptions = [
    {
        key: 'email_marketing_tools',
        title: 'Most popular email marketing tools used by companies',
        description: null,
    },
    {
        key: 'email_marketing_spend',
        title: 'Monthly spending on email marketing tools',
        description: null,
    },
    {
        key: 'email_marketing_value',
        title: 'Value perceived from email marketing tools',
        description: null,
    },
    {
        key: 'ecomm_platform',
        title: 'E-commerce platforms being used.',
        description: null,
    },
    {
        key: 'attribution_software',
        title: 'Attribution software being used.',
        description: null,
    },
    {
        key: 'attribution_software_spend',
        title: 'Monthly spending on attribution software',
        description: null,
    },
    {
        key: 'attribution_software_value',
        title: 'Value perceived from attribution software',
        description: null,
    },
    {
        key: 'reporting_software',
        title: 'Reporting software being used.',
        description: null,
    },
    {
        key: 'reporting_software_spend',
        title: 'Monthly spending on reporting software',
        description: null,
    },
    {
        key: 'reporting_software_value',
        title: 'Value perceived from reporting software',
        description: null,
    },
];

export const ToolingReport: ReportV2Dto = {
    id: 'tooling',
    name: 'Tooling',
    tagline: null,
    description: `Learn what tools are used by other companies, and compare which tools are used by companies with better metrics (obtained from Varos integrations)`,
    category: 'marketing',
    dataset: DatasetSlugs.TOOLING,
    traits: [],
    tags: ['strategy', 'trends'],
    dependencies: [
        {
            kind: 'survey',
            dataset: DatasetSlugs.TOOLING,
        },
    ],
    thumbnail: {
        description: null,
        url: thumbnail,
    },
    images: [
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
    ],
    visualizations: dimensionsWithDescriptions.map((dimension) => ({
        key: dimension.key,
        kind: 'bar', // Assuming bar charts for all dimensions. Adjust as needed.
        name: dimension.title, // Name of the visualization
        description: dimension.description,
        aggregation: 'count', // Assuming count for all dimensions. Adjust as needed.
        breakdown: {
            keys: [dimension.key],
        },
    })),
};
